import { DynamicRoute } from '../shared/navigation/dynamic-route';
import { NeverShowRouteResolver } from '../shared/navigation/never-show-route-resolver';
import { PermissionLevel } from '../shared/permission/permission';
import { UpdateWarningComponent } from './update-warning.component';

export const updateWarningRoutes: Array<DynamicRoute> = [
  {
    path: 'update-warning',
    component: UpdateWarningComponent,
    data: {
      show: NeverShowRouteResolver,
      title: 'Update',
      permissionLevel: PermissionLevel.MANAGER,
      type: []
    }
  }
];
